export const MIN_ZOOM = 100;
export const MAX_ZOOM = 300;
export const POPOVER_PROPS = {
  position: 'bottom right',
  isAlternate: true
};
//# sourceMappingURL=constants.js.map